export interface PaginationBounds {
  defaultTake?: number;
  maxTake?: number;
}

export interface NormalizedPagination {
  skip: number;
  take: number;
}

/**
 * Normalize pagination values to prevent large scans and enforce sane defaults.
 * - Ensures skip >= 0
 * - Ensures take is within [1, maxTake], defaulting to defaultTake when not provided
 */
export function normalizePagination(
  skip: number,
  take: number,
  bounds: PaginationBounds = { defaultTake: 25, maxTake: 100 },
): NormalizedPagination {
  const DEFAULT_TAKE = bounds.defaultTake ?? 25;
  const MAX_TAKE = bounds.maxTake ?? 100;

  const normalizedSkip = Math.max(0, Number.isFinite(skip) ? Number(skip) : 0);
  const requestedTake = Number.isFinite(take) ? Number(take) : DEFAULT_TAKE;
  const normalizedTake = Math.min(Math.max(1, requestedTake), MAX_TAKE);

  return { skip: normalizedSkip, take: normalizedTake };
}
